export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'all',
    name: '全部',
    icon: 'ri-apps-line',
    description: '浏览全部影视内容，发现精彩佳作'
  },
  {
    id: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    description: '高清电影大片，4K蓝光画质，震撼视听体验'
  },
  {
    id: 'tv',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧全集，追剧不等待，一口气看完'
  },
  {
    id: 'anime',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '热门动漫新番，经典动漫回顾，二次元世界'
  },
  {
    id: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目，欢笑不断，轻松解压'
  }
];

export const genres = [
  '全部', '科幻', '动作', '剧情', '喜剧', '悬疑', '犯罪', '奇幻',
  '动画', '历史', '古装', '战争', '传记', '音乐', '户外', '竞技', '冒险', '权谋'
];

export const years = ['全部', '2027', '2026', '2025', '2024', '2023', '2022', '2021'];
export const regions = ['全部', '中国大陆', '美国', '日本', '韩国', '英国', '其他'];
export const qualities = ['全部', '4K HDR', '4K IMAX', '4K', '蓝光', '超清', '高清'];